export const ERROR_PAGE_TYPE = {
  defaultError: 0,
  beetNotAvailable: 1,
}

export default { ERROR_PAGE_TYPE }
